<template>
  <div>
    <v-layout wrap class="px-3">
      <v-flex xs12>
        <span class="caption grey--text left">Tipo de logbook:</span><br />
        <v-select
          v-model="selectedStats.logbookType"
          :loading="fetchingLogs"
          :items="logtypes"
          item-value="id"
          item-text="name"
          clearable
          solo
          class="thin-border"
        />
        <span v-if="interns" class="caption grey--text left">Interno:</span
        ><br />
        <v-select
          v-if="interns"
          v-model="selectedUsersLogs"
          :loading="fetchingLogs"
          item-value="value"
          :items="coordinatedUsers"
          multiple
          return-object
          clearable
          solo
          class="thin-border"
        />
        <v-radio-group v-if="interns" v-model="selectedRadios" row>
          <v-radio label="Dados Agregados" value="radio-1"></v-radio>
          <v-radio label="Dados Individualizados" value="radio-2"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <template v-if="selectedStats.logbookType">
      <v-tabs
        color="grey lighten-4"
        v-model="paramTabs"
        fixed-tabs
        grow
        style="width: 100%"
      >
        <v-tab href="#options">
          <span class="caption font-weight-bold">Opções</span>
          <Icon name="gear" color="#fff" size="24px" class="ml-1" />
        </v-tab>
        <v-tab href="#filters">
          <span class="caption font-weight-bold">Filtros</span>
          <Icon name="filter" size="24px" class="ml-1" />
        </v-tab>
      </v-tabs>
      <v-layout class="px-3">
        <v-tabs-items v-model="paramTabs" style="width: 100%">
          <v-tab-item value="options">
            <h4 class="mt-3 primary--text">Modo de Visualização:</h4>
            <v-flex xs12>
              <v-toolbar dense flat class="transparent second-toolbar mt-1">
                <v-btn-toggle
                  max="350px"
                  v-model="selectedStats.selectedDisplayMode"
                  class="transparent"
                  mandatory
                >
                  <v-btn
                    v-for="option in displayModeOptions"
                    :key="option.value"
                    :value="option.value"
                    flat
                  >
                    <Icon size="18px" :name="option.icon" />
                    <span class="pl-1">{{ option.text }}</span>
                  </v-btn>
                </v-btn-toggle>
              </v-toolbar>
            </v-flex>
            <v-flex xs12>
              <v-divider />
              <v-tabs v-model="selectedStats.tableType" grow>
                <v-tab href="#resume" v-if="showResumeTableTab">
                  Tabela Resumo
                </v-tab>
                <v-tab href="#variables"> Variáveis </v-tab>
              </v-tabs>
              <v-card width="100%" flat class="border grey--border semi-round">
                <v-card-text>
                  <v-tabs-items v-model="selectedStats.tableType">
                    <v-tab-item value="resume" v-if="showResumeTableTab">
                      <v-radio-group
                        class="my-0"
                        v-model="selectedStats.selectedResumeTable"
                      >
                        <template v-for="(resumeTable, index) in resumeTables">
                          <v-radio
                            v-if="showResumeTable(resumeTable)"
                            :key="index"
                            :label="resumeTable.label"
                            :value="resumeTable.value"
                          ></v-radio>
                        </template>
                      </v-radio-group>
                    </v-tab-item>
                    <v-tab-item value="variables">
                      <VariablesSelector
                        :displayMode="selectedStats.selectedDisplayMode"
                        :logbookType="selectedStats.logbookType"
                        :interns="interns"
                        :vars.sync="selectedStats.variables"
                        :row1Disabled="
                          selectedRadios === 'radio-1' ? false : true
                        "
                      />
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-tab-item>
          <v-tab-item value="filters" style="width: 100%">
            <h4 class="mt-3 primary--text">Filtrar por:</h4>
            <v-flex xs12>
              <span class="caption grey--text left mt-1">Data:</span><br />
              <DateRange
                class="mb-3"
                :startDate.sync="startDate"
                :endDate.sync="endDate"
                singleDatePicker="range"
              />
            </v-flex>
            <v-flex v-if="showInternshipSelector" xs12>
              <span class="caption grey--text left">Estágio:</span><br />
              <v-select
                v-model="selectedStats.selectedInternship"
                :items="labeledInterships"
                item-text="text"
                item-value="internship"
                :hint="internshipSelectorHint"
                persistent-hint
                clearable
                single-line
                solo
                class="thin-border"
              />
            </v-flex>
            <v-flex v-if="showSpecialtySelector" xs12>
              <span class="caption grey--text left">Especialidade:</span><br />
              <v-select
                v-model="selectedStats.selectedSpecialty"
                :items="userSpecialties"
                item-text="text"
                item-value="value"
                :hint="specialtySelectorHint"
                persistent-hint
                clearable
                single-line
                solo
                class="thin-border"
              />
            </v-flex>
          </v-tab-item>
        </v-tabs-items>
      </v-layout>
    </template>
    <div class="mx-2 mt-3">
      <v-btn
        depressed
        round
        color="secondary"
        @click="$root.$emit('statsdrawer', false)"
        >Ver estatisticas</v-btn
      >
    </div>
  </div>
</template>

<script>
import { Logbook } from '../../models/Specialty'
import { mapGetters } from 'vuex'
import DateRange from './DateRange.vue'
import VariablesSelector from './VariablesSelector.vue'
import cms from '@/content'
import { Internship, Option } from '../../models/Specialty'
export default {
  props: {
    interns: { type: Boolean, default: false },
    internships: { type: Array, default: () => [] },
    selectedUsers: { type: Array },
    statsData: { type: Object },
    resumeTables: { type: Array },
    userSpecialties: { type: Array },
    coordinatedUsers: { type: Array },
    fetchingLogs: { type: Boolean, default: true },
    dateFilter: { type: Object }
  },
  components: {
    DateRange,
    VariablesSelector
  },
  data() {
    return {
      selectedStats: {
        specialty: null,
        logbookType: null,
        selectedDisplayMode: 'table',
        tableType: null,
        selectedResumeTable: '',
        variables: {},
        selectedInternship: null,
        selectedSpecialty: null
      },
      selectedUsersLogs: [],
      filterByInternship: null,
      filterBySpecialty: null,
      chartOptions: { labelPosition: 'top' },
      selectedRadios: 'radio-1',
      resumeToDisplay: '',
      paramTabs: 'options',
      startDate: this.dateFilter.startDate,
      endDate: this.dateFilter.endDate
    }
  },
  methods: {
    //After every implementation is dynamic we can delete this function
    getInternshipLabel(id) {
      let internship = {}
      const option = Option.query().where('value', id).first()
      if (option) return option.text

      if (this.$store.getters.specialty === 'general-surgery') {
        internship =
          cms.getInternships(this.$i18n.locale).find(i => i.value === id) || {}
      } else {
        const internshipOption =
          this.internshipItems.find(i => i.id === id) || {}
        internship = { text: internshipOption.name }
      }
      return internship.text || id
    },
    showResumeTable(resumeTable) {
      const showtable =
        this.selectedStats.logbookType === resumeTable.logbook ||
        (Array.isArray(resumeTable.logbook)
          ? resumeTable.logbook.includes(this.selectedStats.logbookType)
          : resumeTable.logbook === this.selectedStats.logbookType)
      return (
        showtable &&
        resumeTable.specialty.includes(this.$store.getters.specialty)
      )
    }
  },
  computed: {
    ...mapGetters([
      'logs',
      'coordinatorLogs',
      'coordinatorInternships',
      'specialty'
    ]),
    logtypes() {
      return Logbook.query().get()
    },
    internshipItems() {
      return Internship.query().get()
    },
    labeledInterships() {
      return this.internships.map(i => {
        return { ...i, text: this.getInternshipLabel(i.internship) }
      })
    },
    displayModeOptions() {
      let options1 = []
      let options = [
        { text: 'Tabela', value: 'table', icon: 'table' },
        {
          text: 'Gráf. barras',
          value: 'bar',
          icon: 'bar-chart'
        }
      ]
      if (this.selectedRadios === 'radio-1') {
        options1 = [
          {
            text: 'Gráf. circular',
            value: 'pie',
            icon: 'pie-chart'
          }
        ]
      }
      return [...options, ...options1]
    },
    showResumeTableTab() {
      const possibleLogbooks = this.resumeTables.flatMap(item => item.logbook)
      const isRightSpeciality =
        this.resumeTables.findIndex(item => {
          return item.specialty.includes(this.$store.getters.specialty)
        }) !== -1
      const isRightLogbook = possibleLogbooks.includes(
        this.selectedStats.logbookType
      )
      return (
        this.selectedStats.selectedDisplayMode == 'table' &&
        isRightSpeciality &&
        isRightLogbook &&
        !this.interns
      )
    },
    showInternshipSelector() {
      return (
        this.selectedStats.selectedResumeTable !== 'resumeByInternship' &&
        this.selectedStats.selectedResumeTable !== 'resumeBySpecialty'
      )
    },
    internshipSelectorHint() {
      return this.selectedStats.selectedResumeTable === 'resumeByDiagnose' &&
        !this.selectedStats.selectedInternship &&
        this.selectedStats.selectedDisplayMode !== 'variables'
        ? 'Escolha um estágio'
        : ''
    },
    showSpecialtySelector() {
      return (
        this.selectedStats.selectedResumeTable !== 'resumeByInternship' &&
        this.selectedStats.selectedResumeTable !== 'resumeBySpecialty' &&
        this.selectedStats.logbookType === 'anesthesia'
      )
    },
    specialtySelectorHint() {
      return this.selectedStats.selectedResumeTable === 'resumeByDiagnose' &&
        !this.selectedStats.selectedSpecialty &&
        this.selectedStats.selectedDisplayMode !== 'variables'
        ? 'Escolha uma especialide'
        : ''
    }
  },
  mounted() {
    this.$root.$on('displayGraph', val => {
      this.selectedStats.selectedDisplayMode = val.displayMode
      this.$set(this.selectedStats, 'tableType', val.display)
      val.resumeTable
        ? this.$set(this.selectedStats, 'selectedResumeTable', val.resumeTable)
        : ''
    })
  },
  watch: {
    dateFilter: {
      handler(val) {
        this.startDate = val.startDate
        this.endDate = val.endDate
      },
      deep: true
    },
    'statsData.logbookType'(val, old) {
      if (val !== old) {
        this.selectedStats.logbookType = val
      }
    },
    selectedStats: {
      deep: true,
      handler(val) {
        this.$emit('update:statsData', val)
      }
    },
    'selectedStats.selectedResumeTable'(val, old) {
      if (val !== old) {
        this.$emit('update:showStats', true)
      }
      if (val === 'resumeByDiagnose') {
        this.paramTabs = 'filters'
      }
    },
    'selectedStats.variables': {
      handler(val, old) {
        if (val !== old) {
          this.$emit('update:showStats', true)
        }
      },
      deep: true
    },
    selectedUsersLogs(val) {
      this.$emit('update:selectedUsers', val)
    },
    selectedRadios(val) {
      this.selectedStats.variables.row2 = null
      this.selectedStats.variables.column1 = null
      this.selectedStats.variables.column2 = null
      switch (val) {
        case 'radio-2':
          this.selectedStats.variables.row1 = { id: 'userId' }
          break
        case 'radio-1':
          this.selectedStats.variables.row1 = null
      }
    }
  }
}
</script>
<style>
.estagio .v-messages__message {
  color: red;
}
.semi-round {
  border-radius: 0 0 10px 10px !important;
}
</style>
